import React, { useEffect } from "react";
import UserWrapper from "views/Branch/user.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import TillTable from "components/till/TillTable";

const Till = props => {
  const { isStore } = props;
  const branchId = props.match && props.match.params && props.match.params.branchId;
  const branchName =
    props.location && props.location.state && props.location.state.branchName
      ? props.location.state.branchName
      : `Branch ${branchId}`;

  useEffect(() => {
    if (!branchId) {
      props.history.push(!isStore ? "/branch" : "/store/branch");
    }
  }, [branchId]);

  return (
    <UserWrapper {...props}>
      <PageTitle
        title={`Tills - ${branchName}`}
        className="plr-15"
        breadCrumb={[
          {
            name: !isStore ? "sidebar.dashboard" : "sidebar.storeDashboard"
          },
          {
            name: "sidebar.branch",
            route: !isStore ? "/branch" : "/store/branch"
          },
          {
            name: "Tills"
          }
        ]}
      />
      <div className="user-tbl">
        <TillTable branchId={parseInt(branchId, 10)} isStore={isStore} {...props} />
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.storeID
  };
};

export default connect(mapStateToProps)(Till);

